import React, { useState } from "react";
import { Select, Input, Button, Checkbox } from "antd";
interface IProps {}

/**
 * @author
 * @function @
 **/

function BookingStatusFilter({
  cancelledBookingCheck,
  bookingStatuses,
  bookingStatusFilter,
  minWidth,
  checkBoxValue,
  setCheckBoxValue,
  bookingStatusTitle,
  checkBoxLabel,
  currentScreen,
}: any) {
  const { Option } = Select;
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const getCheckBoxValue = (value) => {
    setCheckBoxValue(value);
    setOpen(false);
  };

  const setSelectStatus = (e) => {
    bookingStatusFilter(e);
    setStatus(e);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minWidth: minWidth }}>
      <span style={{ color: "gray" }}>{bookingStatusTitle}</span>
      <Select
        defaultValue="All"
        bordered={true}
        labelInValue
        suffixIcon={null}
        notFoundContent={
          <div style={{ textAlign: "center", color: "#888", position: "absolute", zIndex: "-1px" }}>No data found</div>
        } // Custom "No Data" placeholder with reduced height
        showSearch
        allowClear={status?.value === undefined || status?.value === "all" ? false : true}
        filterOption={(input: any, option: any) => {
          return (option?.children ?? "")?.toLowerCase().includes(input.toLowerCase());
        }}
        size="large"
        onChange={(e) => setSelectStatus(e)}
        open={open}
        onDropdownVisibleChange={(visible) => setOpen(visible)}
        dropdownRender={(menu) => (
          <div>
            {menu}
            {cancelledBookingCheck && (status?.value === "all" || !status || currentScreen === "lease") && (
              <div style={{ padding: "10px" }}>
                <Checkbox checked={checkBoxValue} onChange={(e) => getCheckBoxValue(e.target?.checked)}>
                  {checkBoxLabel ? checkBoxLabel : "Show Cancelled Bookings"}
                </Checkbox>
              </div>
            )}
          </div>
        )}
      >
        {bookingStatuses?.map((item, index) => (
          <Option key={item?.value + index} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
    </div>
  );
}
export default React.memo(BookingStatusFilter);
